import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import localePt from '@angular/common/locales/pt';
import { IonicModule } from '@ionic/angular';
import { HeaderComponent } from './components/header/header.component';
import { HeaderSimplesComponent } from './components/header-simples/header-simples.component';
import { CameraOverlayComponent } from './components/camera-overlay/camera-overlay.component';
import { CameraScanButtonComponent } from './components/camera-scan-button/camera-scan-button.component';
import { QRCodeModule } from 'angularx-qrcode';

registerLocaleData(localePt);

const loadModules = [
  CommonModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
  IonicModule,
  QRCodeModule
];

@NgModule({
  declarations: [
    HeaderComponent,
    HeaderSimplesComponent,
    CameraOverlayComponent,
    CameraScanButtonComponent,
  ],
  imports: [
    ...loadModules
  ],
  exports: [
    ...loadModules,
    HeaderComponent,
    HeaderSimplesComponent,
    CameraOverlayComponent,
    CameraScanButtonComponent,
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'pt-PT',
    },
  ],
})
export class SharedModule { }
